import { Outlet } from 'react-router-dom';
import { type NavGroup, Sidebar } from './Sidebar';
import { Header } from './Header';

export function AppShell({
  title,
  subtitle,
  headerTitle,
  headerSubtitle,
  headerActions,
  groups,
  onLogout,
  footer,
}: {
  title: string;
  subtitle: string;
  headerTitle: string;
  headerSubtitle?: string;
  headerActions?: React.ReactNode;
  groups: NavGroup[];
  onLogout?: () => void;
  footer?: React.ReactNode;
}) {
  return (
    <div className="flex min-h-screen bg-[var(--color-background)]">
      <Sidebar
        title={title}
        subtitle={subtitle}
        groups={groups}
        onLogout={onLogout}
        footer={footer}
      />
      <div className="flex flex-1 flex-col">
        <Header title={headerTitle} subtitle={headerSubtitle} actions={headerActions} />
        <main className="flex-1 overflow-auto p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
